export default __webpack_public_path__ + "static/581-1f016a61c0e3398f299d4add472571b5.gif";